export default __webpack_public_path__ + "static/media/CourseDescriptionV201.26e3bff9.png";